if (!customElements.get('pp-sale-countdown')) {
  class PPSaleCountdown extends HTMLElement {
    connectedCallback() {
      this.clock = this.querySelector('[data-countdown-clock]');
      this.expiredStatus = this.querySelector('[data-countdown-expired]');
      this.invalidStatus = this.querySelector('[data-countdown-invalid]');
      this.output = {
        days: this.querySelector('[data-countdown-days]'),
        hours: this.querySelector('[data-countdown-hours]'),
        minutes: this.querySelector('[data-countdown-minutes]'),
        seconds: this.querySelector('[data-countdown-seconds]'),
      };

      const endAt = (this.dataset.endAt || '').trim();
      if (!endAt) return;

      this.endTime = this.parseDeadline(endAt);

      if (!Number.isFinite(this.endTime)) {
        this.handleInvalidDeadline();
        return;
      }

      this.clock.hidden = false;
      this.update();
      if (this.endTime > Date.now()) {
        this.interval = window.setInterval(() => this.update(), 1000);
      }
    }

    disconnectedCallback() {
      this.stop();
    }

    parseDeadline(value) {
      const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/.exec(value);
      if (!match) return Number.NaN;

      const year = Number(match[1]);
      const month = Number(match[2]);
      const day = Number(match[3]);
      const hour = Number(match[4]);
      const minute = Number(match[5]);
      const second = Number(match[6] || 0);
      const localCalendar = new Date(0);

      localCalendar.setUTCHours(hour, minute, second, 0);
      localCalendar.setUTCFullYear(year, month - 1, day);

      const hasValidCalendar =
        localCalendar.getUTCFullYear() === year &&
        localCalendar.getUTCMonth() === month - 1 &&
        localCalendar.getUTCDate() === day &&
        localCalendar.getUTCHours() === hour &&
        localCalendar.getUTCMinutes() === minute &&
        localCalendar.getUTCSeconds() === second;
      const timestamp = hasValidCalendar ? Date.parse(value) : Number.NaN;

      return Number.isFinite(timestamp) ? timestamp : Number.NaN;
    }

    update() {
      const remaining = Math.max(0, this.endTime - Date.now());

      if (remaining === 0) {
        this.handleExpired();
        return;
      }

      const day = 86_400_000;
      const hour = 3_600_000;
      const minute = 60_000;
      const second = 1000;

      this.write('days', Math.floor(remaining / day));
      this.write('hours', Math.floor((remaining % day) / hour));
      this.write('minutes', Math.floor((remaining % hour) / minute));
      this.write('seconds', Math.floor((remaining % minute) / second));
    }

    write(unit, value) {
      if (this.output[unit]) this.output[unit].textContent = String(value).padStart(2, '0');
    }

    handleExpired() {
      this.stop();
      this.clock.hidden = true;

      if (this.dataset.designMode === 'true') {
        if (this.expiredStatus) this.expiredStatus.hidden = false;
        return;
      }

      switch (this.dataset.expiredBehavior) {
        case 'hide_section':
          this.hideSection();
          break;
        case 'hide_timer':
          if (this.dataset.hasFallbackContent !== 'true') this.hideSection();
          break;
        default:
          if (this.expiredStatus) this.expiredStatus.hidden = false;
      }
    }

    handleInvalidDeadline() {
      this.clock.hidden = true;

      if (this.dataset.designMode === 'true') {
        if (this.invalidStatus) this.invalidStatus.hidden = false;
      } else if (this.dataset.hasFallbackContent !== 'true') {
        this.hideSection();
      }
    }

    hideSection() {
      const section = this.closest('.pp-sale-countdown');
      if (section) section.hidden = true;
      else this.hidden = true;
    }

    stop() {
      if (!this.interval) return;
      window.clearInterval(this.interval);
      this.interval = undefined;
    }
  }

  customElements.define('pp-sale-countdown', PPSaleCountdown);
}
